export default function () {
    $(document).ready(() => {
        const loader = $("<div class='tx-solr-loader'><div class='lds-dual-ring'></div></div>");

        $('.news').on('click', '.page-navigation a', (e) => {
            e.preventDefault();
            e.stopPropagation();

            $('a.news-pagination-ajaxifieid').removeClass('active');
            $(e.target).addClass('active');

            const ajaxUrl = $(e.target).data('link');
            const container = 'news-container-' + $(e.target).data('container');

            $('#' + container).prepend(loader);

            if ($('.news').find('.news-list-view__vertical').length || $('.news').find('.blog__allnews').length) {
                $('html, body').animate({
                    scrollTop: $('#' + container).offset().top,
                });
            }

            if (ajaxUrl !== undefined && ajaxUrl !== '') {
                e.preventDefault();

                $.ajax({
                    url: ajaxUrl,
                    type: 'GET',
                    success: (result) => {
                        const ajaxDom = $(result).find('#' + container);
                        $('#' + container).replaceWith(ajaxDom);
                    },
                });
            }
        });
    });
}
